import React, { useEffect, useState } from "react";
import "../../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "./tasks.css"
import TaskTab from "./TaskTab"
import SupportLink from "../../Common/SupportLink";

import { exportTasks } from 'api/ExportApi'

function Tasks(props) {
    const [currentTab, setCurrentTab] = useState("task_all");
    const [isAdmin, setIsAdmin] = useState(false);

    const ALL_TAB = {
        name: 'All',
        id: 'task_all',
        status: 'active',
        tab: 'all',
    };
    const DUE_TODAAY_TAB = {
        name: 'Due Today',
        id: 'task_due',
        status: '',
        tab: 'duetoday',
    };
    const Completed_TAB = {
        name: 'Completed',
        id: 'task_completed',
        status: '',
        tab: 'completed',
    };
    const OverDue_TAB = {
        name: 'Overdue',
        id: 'task_overdue',
        status: '',
        tab: 'overdue',
    };
    const TABS = [ALL_TAB, DUE_TODAAY_TAB, OverDue_TAB, Completed_TAB];
    const tabChanged = (tab) => {
        TABS.map(t => {
            if (t.id === tab.id)
                t.status = 'active'
            else
                t.status = ''
        })
        setCurrentTab(tab.id)
    };
    const NavTab = (tab) => {
        let currentStatus = '';
        if (currentTab === tab.tabinfo.id) {
            currentStatus = 'active';
        } else {
            currentStatus = '';
        }
        return (
            <li className='nav-item'>
                <a
                    onClick={() => {
                        tab.tabChanged(tab.tabinfo);
                    }}
                    className={`nav-link ${currentStatus}`}
                    href={'#' + tab.tabinfo.id}
                    role='tab'
                    data-toggle='tab'
                    key={tab.key_id}
                >
                    <i className={tab.tabinfo.icon}></i> {tab.tabinfo.name}
                </a>
            </li>
        );
    };

    function updateRole() {
        let t = localStorage.getItem('role');
        setIsAdmin(t === 'admin');
    }
    useEffect(() => {
        updateRole()
        window.addEventListener('storage', updateRole)

    }, [])

    return (
        <div className='templates'>
            <SupportLink link='https://kapitalwise.com/user-guide/sales/' />

            <div className='page_heading'>
                <h2>Task List</h2>
            </div>
            {isAdmin && <div className="export" >
                <input
                    onClick={exportTasks}
                    type="submit"
                    name="Save"
            
                    className="add__stage lg_btn primary"
                    value="Export"
                />   
                </div>}

            <div className='cmpgn_list_outer'>
                <div className='cmpgn_tab_erap'>
                    <ul className='nav nav-tabs' role='tablist'>
                        {TABS.map((tab, index) => {
                            return (
                                <NavTab
                                    key={index}
                                    key_id={tab.id}
                                    tabChanged={tabChanged}
                                    tabinfo={tab}
                                />
                            );
                        })}
                    </ul>
                </div>

            </div>
            <TaskTab tasktab={currentTab} />

        </div>
    );
}
export default Tasks;